import React, { useState } from 'react';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import websitelogo from '../../../../assets/logos/websitelogo.svg';

import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';

import CallIcon from '@mui/icons-material/Call';

import ChatIcon from '@mui/icons-material/Chat';

import ContactSupportIcon from '@mui/icons-material/ContactSupport';

import './Signup.css';

import {
	Alert,
	Box,
	Checkbox,
	CssBaseline,
	Grid,
	IconButton,
	InputAdornment,
	Modal,
	OutlinedInput,
	Snackbar,
	TextField,
	Typography,
} from '@mui/material';
import MaskedInput from 'react-text-mask';

import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';

import Paper from '@mui/material/Paper';

import Button from '@mui/material/Button';

import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';

import { Visibility, VisibilityOff } from '@mui/icons-material';

import { useNavigate, Link } from 'react-router-dom';

import { register } from '../../../services/api/apiManager';

import * as Yup from 'yup';
import PrivacyPolicy from './PrivacyPolicy';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	// maxWidth: '500px',
	height: '85vh',
	overflow: 'auto',
	bgcolor: 'white',
	// border: '2px solid #000',
	// boxShadow: 24,
	borderRadius: '5px',
	padding: '10px 4px',
};

function Signup() {
	const defaultTheme = createTheme();
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [openSnackbarError, setOpenSnackbarError] = useState(false);
	const [passwordWrong, setPasswordWrong] = useState(false);
	const [passwordError, setPasswordError] = useState(false);
	const [emptyField, setEmptyFieldError] = useState(false);
	const [email, setEmail] = useState('');
	const [formSubmitted, setFormSubmitted] = React.useState(false);
	const [termsAccepted, setTermsAccepted] = useState(false);
	const [termsCondition, setTermsCondition] = useState(false);
	const [open, setOpen] = React.useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	const navigate = useNavigate();
	const handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbar(false);
	};
	const handleSnackbaErrorClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbarError(false);
		setPasswordWrong(false);
		setTermsCondition(false);
	};
	const handleSnackbaWrongClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setPasswordWrong(false);
	};
	const handlePasswordErrorClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setPasswordError(false);
	};
	const handleEmptyFieldError = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setEmptyFieldError(false);
	};
	const navigateLogin = useNavigate();

	// const handleSignInClick = () => {
	// 	navigateLogin('/'); // Replace '/login' with the actual route of your Login page
	// };

	// const handleButtonClick = () => {
	// 	setOpenSnackbar(true);
	// };
	const handleLoginClick = () => {
		navigate('/');
	};
	const [showPassword, setShowPassword] = React.useState(false);
	const handleClickShowPassword = () => setShowPassword((show) => !show);
	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	const schema = Yup.object().shape({
		first_name: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'only alphabets'),
		last_name: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'only alphabets'),
		email: Yup.string().matches(
			/^[A-Za-z0-9]+[-A-Za-z0-9._]*@([-A-Za-z0-9]+[^@])+[A-Za-z]{2,5}$/,
			'Wrong Email'
		),
		UserContactNo: Yup.string().matches(
			/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
			'Invalid '
		),
		password: Yup.string()
			.required('Password is required')
			.test(
				'special-character',
				'Password must contain at least one special character',
				(value) => /[!@#$%^&*(),.?":{}|<>]/.test(value)
			)
			.test(
				'numeric-character',
				'Password must contain at least one numeric character',
				(value) => /\d/.test(value)
			)
			.test(
				'alphabetic-character',
				'Password must contain at least five alphabetic characters',
				(value) => /[a-zA-Z].*[a-zA-Z].*[a-zA-Z]/.test(value)
			),
		confirmPassword: Yup.string()
			.required('Password is required')
			.test(
				'special-character',
				'Password must contain at least one special character',
				(value) => /[!@#$%^&*(),.?":{}|<>]/.test(value)
			)
			.test(
				'numeric-character',
				'Password must contain at least one numeric character',
				(value) => /\d/.test(value)
			)
			.test(
				'alphabetic-character',
				'Password must contain at least five alphabetic characters',
				(value) => /[a-zA-Z].*[a-zA-Z].*[a-zA-Z]/.test(value)
			),
	});
	const handleChange = (event) => {
		debugger;
		const { name, value } = event.target;
		setFormData({ ...formData, [name]: value });
	};
	const [errors, setErrors] = useState({});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: value,
		}));

		Yup.reach(schema, name)
			.validate(value)
			.then(() => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: '', // Clear error if validation passes
				}));
			})
			.catch((error) => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: error.message, // Set error message if validation fails
				}));
			});
	};

	const [formData, setFormData] = useState({
		is_staff: 'true',
		first_name: '',
		last_name: '',
		email: '',
		UserContactNo: '',
		password: '',
		confirmPassword: '',
	});
	const handleSignup = async () => {
		try {
			debugger;
			event.preventDefault();
			setFormSubmitted(true);

			if (Object.values(formData).some((value) => value === '')) {
				setEmptyFieldError(true);
				return; // Exit function if any field is empty
			}
			// Check if passwords match
			if (formData.password !== formData.confirmPassword) {
				setPasswordError(true);
				return; // Exit function if passwords don't match
			}
			if (!termsAccepted) {
				setTermsCondition(true);
				return; // Do not proceed if terms are not accepted
			}
			// Validate the entire form
			await schema.validate(formData, { abortEarly: false });

			const res = await register(formData);
			// Handle response as needed
			if (res?.status === 201) {
				setOpenSnackbar(true);
				// Optionally, redirect to login page or show success message
				setTimeout(() => {
					navigate('/verification');
				}, 1500);
			} else if (
				res?.response?.data?.msg ==
				"Error in RegisterUser post: {'email': [ErrorDetail(string='user with this Email Address already exists.', code='unique')]}"
			) {
				// If email already exists
				setOpenSnackbarError(true);
			} else {
				setPasswordWrong(true);
			}
		} catch (error) {
			// Handle error
		}
	};
	// const handleChange = (event) => {
	// 	const { name, value } = event.target;
	// 	setFormData({ ...formData, [name]: value });
	// };
	const handleCheckboxChange = (event) => {
		setTermsAccepted(event.target.checked);
	};
	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid
				container
				component="main"
				sx={{
					height: '100vh',
					backgroundImage: `url(${require('../../../../assets/images/background.png')})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					padding: '20px 70px',
					'@media (max-width: 600px)': {
						// Styles for xs and sm screens
						padding: '30px',
					},
				}}
			>
				<CssBaseline />
				<Grid container item justifyContent="center">
					<Grid
						item
						xs={false}
						sm={6}
						md={6}
						lg={5}
						xl={4}
						sx={{
							backgroundImage: `url(${require('../../../../assets/images/singupbacground.png')})`,
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center',
							backgroundSize: 'cover',
							display: 'flex',
							flexDirection: 'column',
							borderRadius: '15px 0px 0px 15px',
							justifyContent: 'space-between',
							// background: '#197CCC',
							display: { sm: 'none', xs: 'none', md: 'flex', xl: 'flex' },
						}}
					>
						<Grid
							item
							sx={{
								display: 'flex',
								flex: '1',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<Box>
								<Typography
									gutterBottom
									variant="h5"
									sx={{
										color: 'white',
										fontSize: '25px',
										fontFamily: 'Poppins',
									}}
								>
									CONCISE FEATURES !
								</Typography>
								<ul
									style={{
										listStylePosition: 'inside',
										fontSize: '18px',
										paddingInlineStart: '20px',
										color: 'white',
										fontFamily: 'Poppins',
									}}
								>
									<li>Effortless Scheduling</li>
									<li>Patient-Centric Insights</li>
									<li>Streamlined Billing</li>
									<li>Enhanced Collaboration</li>
									<li>Progressive Customization Features</li>
								</ul>
							</Box>
						</Grid>
						<Grid
							item
							sx={{
								display: 'flex',
								justifyContent: 'space-evenly',
								borderTop: '0.5px solid rgba(255, 255, 255, 0.40)',
								padding: '15px 50px',
							}}
						>
							<Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1} // Adjust the spacing as needed
							>
								<Grid item>
									<ContactSupportIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/aboutUs'}>
										<Typography
											variant="body1"
											sx={{
												fontSize: '13px',
												color: 'white',
												fontWeight: '700',
												textDecoration: 'underline',
											}}
										>
											About Us
										</Typography>
									</Link>
								</Grid>
							</Grid>

							<Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1} // Adjust the spacing as needed
							>
								<Grid item>
									<CallIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/contactUs'}>
										<Typography
											variant="body1"
											sx={{
												fontSize: '13px',
												color: 'white',
												fontWeight: '700',
												textDecoration: 'underline',
											}}
										>
											Contact Us
										</Typography>
									</Link>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid
						component={Paper}
						square
						item
						xs={12}
						sm={12}
						md={6}
						lg={5}
						xl={4}
						sx={{
							backgroundImage: `url(${require('../../../../assets/images/formbackground.png')})`,
							backgroundRepeat: 'no-repeat',
							backgroundSize: 'cover',
							backgroundPosition: 'center',
							borderRadius: '0px 15px 15px 0px',
							'@media (max-width: 600px)': {
								// Styles for xs and sm screens
								borderRadius: '15px',
							},
							'@media (max-width: 900px)': {
								// Styles for xs and sm screens
								borderRadius: '15px',
								justifyContent: 'center',
							},
							'@media (min-width: 1450px)': {
								// Styles for xs and sm screens
								padding: '10px',
							},
							overflow: 'auto',
						}}
					>
						<Box
							sx={{
								padding: '15px 30px',
								display: 'flex',
								flexDirection: 'column',
								// alignItems: 'center',
								// justifyContent: 'flex-start',
							}}
						>
							<img
								src={websitelogo}
								alt="Your Alt Text"
								style={{
									maxWidth: '200px',
									height: 'auto',
									objectFit: 'contain',
								}}
							/>
							<Typography
								component="h1"
								variant="h5"
								sx={{
									alignSelf: 'start',
									fontSize: '25px',
									fontWeight: '600',
									mt: '5px',
								}}
							>
								Sign Up
							</Typography>
							<Box
								component="form"
								sx={{
									mt: 1,
								}}
							>
								<Grid container spacing={2}>
									<Grid item xs={12} sm={6}>
										<Typography
											variant="body2"
											sx={{ color: '#7E7D7D', fontSize: '15px' }}
										>
											First Name
										</Typography>
										<OutlinedInput
											margin="normal"
											fullWidth
											type="text"
											name="first_name"
											value={formData.first_name}
											onChange={handleInputChange}
											autoFocus
											required
											id="first_name"
											sx={{
												height: '35px',
												marginTop: '8px',
												marginBottom: '8px',
												'& .MuiOutlinedInput-input': {
													padding: '5px 0px 5px 6px',
												},
											}}
											endAdornment={
												<InputAdornment position="end">
													<PersonOutlineOutlinedIcon
														sx={{ color: '#DDE6F1' }}
													/>
												</InputAdornment>
											}
										/>
										{errors.first_name && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.first_name}
											</div>
										)}{' '}
										{/* Display validation error */}
									</Grid>
									<Grid item xs={12} sm={6}>
										<Typography
											variant="body2"
											sx={{ color: '#7E7D7D', fontSize: '15px' }}
										>
											Last Name
										</Typography>
										<OutlinedInput
											margin="normal"
											fullWidth
											type="text"
											name="last_name"
											value={formData.last_name}
											onChange={handleInputChange}
											// autoFocus
											required
											id="last_name"
											sx={{
												height: '35px',
												marginTop: '8px',
												marginBottom: '8px',
												'& .MuiOutlinedInput-input': {
													padding: '5px 0px 5px 6px',
												},
											}}
											endAdornment={
												<InputAdornment position="end">
													<PersonOutlineOutlinedIcon
														sx={{ color: '#DDE6F1' }}
													/>
												</InputAdornment>
											}
										/>
										{errors.last_name && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.last_name}
											</div>
										)}{' '}
										{/* Display validation error */}
									</Grid>
								</Grid>
								<Typography
									variant="body2"
									sx={{ color: '#7E7D7D', fontSize: '15px' }}
								>
									Email Address
								</Typography>
								<OutlinedInput
									margin="normal"
									fullWidth
									height="35px"
									type="email"
									name="email"
									inputProps={{
										autoComplete: 'email',
									}}
									value={formData.email}
									onChange={handleInputChange}
									autoComplete="email"
									// autoFocus
									required
									id="email"
									sx={{
										height: '35px',
										marginTop: '8px',
										marginBottom: '8px',
										'& .MuiOutlinedInput-input': {
											padding: '5px 0px 5px 6px',
										},
									}}
									endAdornment={
										<InputAdornment position="end">
											<MailOutlineOutlinedIcon sx={{ color: '#DDE6F1' }} />
										</InputAdornment>
									}
								/>
								{errors.email && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.email}
									</div>
								)}{' '}
								{/* Display validation error */}
								<Typography
									variant="body2"
									sx={{ color: '#7E7D7D', fontSize: '15px' }}
								>
									Contact No:
								</Typography>
								{/* <OutlinedInput
									margin="normal"
									fullWidth
									type="teltext"
									name="UserContactNo"
									value={formData.UserContactNo}
									onChange={handleInputChange}
									inputProps={{
										autoComplete: '',
									}}
									sx={{
										height: '35px',
										marginTop: '8px',
										marginBottom: '8px',
										'& .MuiOutlinedInput-input': {
											padding: '5px 0px 5px 6px',
										},
									}}
									endAdornment={
										<InputAdornment position="end">
											<PermContactCalendarIcon sx={{ color: '#DDE6F1' }} />
										</InputAdornment>
									}
								/>
								{errors.UserContactNo && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.UserContactNo}
									</div>
								)}{' '} */}
								<TextField
									variant="outlined"
									// placeholder="Enter a phone number"
									fullWidth
									required
									name="UserContactNo"
									value={formData.UserContactNo}
									onChange={handleChange}
									InputProps={{
										endAdornment: (
											<InputAdornment position="start">
												<CallIcon sx={{ color: '#DDE6F1' }} />
											</InputAdornment>
										),
										inputComponent: MaskedInput,
										inputProps: {
											mask: [
												'(',
												/\d/,
												/\d/,
												/\d/,
												')',
												' ',
												/\d/,
												/\d/,
												/\d/,
												'-',
												/\d/,
												/\d/,
												/\d/,
												/\d/,
											],
										},
										sx: {
											borderRadius: '6px',
											height: '40px',
											marginBottom: '8px',
											marginTop: '8px',
											border: '1.5px solid #DDE6F1',
											'& .MuiOutlinedInput-input': {
												padding: '5px 0px 5px 6px',
											},
											boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
										},
									}}
								/>
								{/* Display validation error */}
								<Grid container spacing={2}>
									<Grid item xs={12} sm={6}>
										<Typography
											variant="body2"
											sx={{ color: '#7E7D7D', fontSize: '15px' }}
										>
											Password
										</Typography>
										<OutlinedInput
											fullWidth
											required
											name="password"
											value={formData.password}
											onChange={handleInputChange}
											id="password"
											autoComplete="current-password"
											sx={{
												height: '35px',
												marginBottom: '8px',
												marginTop: '8px',
												'& .MuiOutlinedInput-input': {
													padding: '5px 0px 5px 6px',
												},
											}}
											type={showPassword ? 'text' : 'password'}
											endAdornment={
												<InputAdornment position="end">
													<IconButton
														aria-label="toggle password visibility"
														onClick={handleClickShowPassword}
														onMouseDown={handleMouseDownPassword}
														edge="end"
														sx={{ color: '#DDE6F1' }}
													>
														{showPassword ? <VisibilityOff /> : <Visibility />}
													</IconButton>
												</InputAdornment>
											}
										/>
										{errors.password && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.password}
											</div>
										)}{' '}
										{/* Display validation error */}
									</Grid>
									<Grid item xs={12} sm={6}>
										<Typography
											variant="body2"
											sx={{ color: '#7E7D7D', fontSize: '15px' }}
										>
											Confirm Password
										</Typography>
										<OutlinedInput
											fullWidth
											required
											name="confirmPassword"
											value={formData.confirmPassword}
											onChange={handleInputChange}
											id="confirmPassword"
											autoComplete="current-password"
											type={showPassword ? 'text' : 'password'}
											endAdornment={
												<InputAdornment position="end">
													<IconButton
														aria-label="toggle password visibility"
														onClick={handleClickShowPassword}
														onMouseDown={handleMouseDownPassword}
														edge="end"
														sx={{ color: '#DDE6F1' }}
													>
														{showPassword ? <VisibilityOff /> : <Visibility />}
													</IconButton>
												</InputAdornment>
											}
											sx={{
												height: '35px',
												marginBottom: '8px',
												marginTop: '8px',
												'& .MuiOutlinedInput-input': {
													padding: '5px 0px 5px 6px',
												},
											}}
										/>
										{errors.confirmPassword && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.confirmPassword}
											</div>
										)}{' '}
										{/* Display validation error */}
									</Grid>
								</Grid>
								<Grid container>
									<Grid item xs>
										<Checkbox
											checked={termsAccepted}
											onChange={handleCheckboxChange}
											color="primary"
										/>
										<Typography display="inline">
											I accept the terms{' '}
										</Typography>

										<Typography display="inline"> and </Typography>
										<Typography
											onClick={handleOpen}
											display="inline"
											style={{ color: '#E87511', cursor: 'pointer' }}
										>
											privacy policy
										</Typography>
									</Grid>
								</Grid>
								<Button
									variant="contained"
									fullWidth
									sx={{
										background: ' #e87511',
										borderRadius: '6px',
										height: '30px',
										fontFamily: 'Poppins',
										fontSize: '20px',
										fontWeight: '400',
										marginTop: '5px',
										marginBottom: '15px',
										'&:hover': {
											background: '#e87511',
										},
									}}
									onClick={() => handleSignup()}
								>
									SIGN UP
								</Button>
								<Grid
									container
									spacing={2}
									sx={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										textAlign: 'center',
										paddingTop: '0px',
									}}
								>
									<Grid
										item
										display={'flex'}
										alignItems={'center'}
										flexDirection={'row'}
										justifyContent={'space-between'}
										gap={'6px'}
									>
										<Typography
											variant="body1"
											sx={{
												fontFamily: 'Poppins',
												color: '#7E7D7D',
												fontSize: '15px',
											}}
										>
											Already have an account?
										</Typography>
										<Link to={'/'}>
											<Typography
												variant="body1"
												sx={{
													fontFamily: 'Poppins',
													// color: 'black',
													fontSize: '15px',
													// display:'flex',
													// justifyContent:'flex-end'
												}}
											>
												{'Login >'}
											</Typography>
										</Link>
									</Grid>
								</Grid>
								{/* <Button
									variant="outlined"
									fullWidth
									sx={{
										color: ' #e87511', // Text color
										borderColor: ' #e87511', // Border color
										borderRadius: '6px',
										height: '30px',
										width: '100%',
										fontSize: '20px',
										fontWeight: '400',
										// marginTop: '15px',
										border: ' 2px solid #E87511',
										'&:hover': {
											borderColor: '#e87511',
										},
									}}
									onClick={handleSignInClick}
								>
									SIGN IN
								</Button> */}
							</Box>
						</Box>
					</Grid>
				</Grid>
				{/* snack bars */}
				{/* snack bar for Email Exists */}
				<Snackbar
					open={openSnackbarError}
					autoHideDuration={6000} // Adjust the duration as needed
					onClose={handleSnackbaErrorClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleSnackbaErrorClose}
						severity="error"
						sx={{
							backgroundColor: 'red',
							fontSize: '17px',
							color: 'white',
							fontFamily: 'Poppins',
							padding: '15px',
							'& .MuiAlert-icon': {
								color: 'white', // Change icon color to white
							},
						}}
					>
						Email already exists.....
					</Alert>
				</Snackbar>
				{/* snack bar for other Error */}
				<Snackbar
					open={passwordWrong}
					autoHideDuration={1500} // Adjust the duration as needed
					onClose={handleSnackbaWrongClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleSnackbaWrongClose}
						severity="error"
						sx={{
							backgroundColor: 'red',
							fontSize: '17px',
							color: 'white',
							fontFamily: 'Poppins',
							padding: '15px',
							'& .MuiAlert-icon': {
								color: 'white', // Change icon color to white
							},
						}}
					>
						Something went Wrong
					</Alert>
				</Snackbar>
				{/* snack bar for empty field  */}
				<Snackbar
					open={emptyField}
					autoHideDuration={6000} // Adjust the duration as needed
					onClose={handleEmptyFieldError}
					anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
				>
					<Alert
						onClose={handleEmptyFieldError}
						severity="error"
						sx={{
							backgroundColor: 'red',
							fontSize: '17px',
							color: 'white',
							fontFamily: 'Poppins',
							padding: '15px',
							'& .MuiAlert-icon': {
								color: 'white', // Change icon color to white
							},
						}}
					>
						Fill all the Fields
					</Alert>
				</Snackbar>
				{/* snack bar for Terms and Conditions  */}
				<Snackbar
					open={termsCondition}
					autoHideDuration={2000} // Adjust the duration as needed
					onClose={handleSnackbaErrorClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleSnackbaErrorClose}
						severity="error"
						sx={{
							backgroundColor: 'red',
							fontSize: '17px',
							color: 'white',
							fontFamily: 'Poppins',
							padding: '15px',
							'& .MuiAlert-icon': {
								color: 'white', // Change icon color to white
							},
						}}
					>
						Please Accept Terms & Conditions
					</Alert>
				</Snackbar>
				{/* snack bar for password not matched  */}
				<Snackbar
					open={passwordError}
					autoHideDuration={6000} // Adjust the duration as needed
					onClose={handlePasswordErrorClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handlePasswordErrorClose}
						severity="error"
						sx={{
							backgroundColor: 'red',
							fontSize: '17px',
							color: 'white',
							fontFamily: 'Poppins',
							padding: '15px',
							'& .MuiAlert-icon': {
								color: 'white', // Change icon color to white
							},
						}}
					>
						Password not Matched
					</Alert>
				</Snackbar>
				{/* Snackbar for account created  */}
				<Snackbar
					open={openSnackbar}
					autoHideDuration={6000} // Adjust the duration as needed
					onClose={handleSnackbarClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleSnackbarClose}
						severity="success"
						sx={{
							backgroundColor: '#3EAE4D',
							fontSize: '20px',
							padding: '15px',
							'& .MuiAlert-icon': {
								color: 'white', // Change icon color to white
							},
						}}
					>
						Account has been created! You may{' '}
						<span
							onClick={handleLoginClick}
							style={{
								cursor: 'pointer',
								textDecoration: 'underline',
								color: 'white',
							}}
						>
							LOG IN
						</span>
					</Alert>
				</Snackbar>

				{/* Terms and privacy modal */}
				<Modal
					open={open}
					// onClose={handleClose}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<Box sx={style}>
						<Typography id="modal-modal-description">
							<PrivacyPolicy />
						</Typography>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'flex-end',
								right: 25,
								paddingBottom: '15px',
							}}
						>
							<Button variant="outlined" onClick={() => setOpen(false)}>
								ok
							</Button>
						</Box>
					</Box>
				</Modal>
			</Grid>
		</ThemeProvider>
	);
}

export default Signup;
